"use strict";

import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _get from "@babel/runtime/helpers/get";
import _inherits from "@babel/runtime/helpers/inherits";
import BaseControl from "D5Utils/form_fields/BaseControl";

var SelectControl =
/*#__PURE__*/
function (_BaseControl) {
  _inherits(SelectControl, _BaseControl);

  function SelectControl() {
    _classCallCheck(this, SelectControl);

    return _possibleConstructorReturn(this, _getPrototypeOf(SelectControl).apply(this, arguments));
  }

  _createClass(SelectControl, [{
    key: "_buildControlProps",
    value: function _buildControlProps() {
      return _objectSpread({}, _get(_getPrototypeOf(SelectControl.prototype), "_buildControlProps", this).call(this), {
        showClearButton: true,
        searchEnabled: true
      }, this.props || {});
    }
  }, {
    key: "instance",
    value: function instance() {
      return this.$_element.dxSelectBox('instance');
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.$_element.dxSelectBox('dispose');
      this.$_element.remove();
    }
  }, {
    key: "render",
    value: function render() {
      this.$_element = this.$_element.dxSelectBox(_objectSpread({}, this._buildControlProps()));
    }
  }]);

  return SelectControl;
}(BaseControl);

export { SelectControl as default };